import { render } from "./VerFormulario.vue?vue&type=template&id=e8b074b8&scoped=true"
import script from "./VerFormulario.vue?vue&type=script&lang=js"
export * from "./VerFormulario.vue?vue&type=script&lang=js"

import "./VerFormulario.vue?vue&type=style&index=0&id=e8b074b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b074b8"]])

export default __exports__